export const BASE = "https://api.caro.bid/v1";

